// https://vuex.vuejs.org/en/state.html
export default {
  query: state => state.query,
  types: state => state.types,
};
